import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Select, Textarea, Btn } from "@/components/UI";
import { CUSTOMER_TYPES, EMPTY_CUSTOMER, apiError } from "@/lib/customers";

const toForm = (c) => ({ ...EMPTY_CUSTOMER, ...(c || {}), default_payment_days: c?.default_payment_days ? String(c.default_payment_days) : "" });

export function CustomerFormModal({ open, customer, onClose, onSaved }) {
  const [f, setF] = useState(toForm(customer));
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setF(toForm(customer)); setErr(""); } }, [open, customer]);
  const set = (k) => (e) => { setErr(""); setF({ ...f, [k]: e.target.value }); };

  const save = async () => {
    if (!f.legal_name.trim()) return setErr("Firma adı zorunludur");
    if (!f.customer_type) return setErr("Müşteri tipi seçiniz");
    const payload = { ...f, default_payment_days: f.default_payment_days === "" ? null : Number(f.default_payment_days) };
    setBusy(true); setErr("");
    try {
      const saved = customer ? await api.put(`/customers/${customer.id}`, payload) : await api.post("/customers", payload);
      onSaved(saved);
    } catch (e) { setErr(apiError(e, "Kaydedilemedi")); }
    finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title={customer ? "Müşteri Kartını Düzenle" : "Yeni Müşteri Kartı"} size="lg">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="customer-form">
        <div className="sm:col-span-2"><Input label="Firma Adı *" value={f.legal_name} onChange={set("legal_name")} data-testid="cust-form-name" /></div>
        <Select label="Müşteri Tipi *" value={f.customer_type} onChange={set("customer_type")} data-testid="cust-form-type">
          <option value="">Seçiniz…</option>
          {CUSTOMER_TYPES.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
        </Select>
        <Input label="Varsayılan Vade (gün)" type="number" min="0" max="365" placeholder="Boşsa 0" value={f.default_payment_days} onChange={set("default_payment_days")} data-testid="cust-form-days" />
        <Input label="Yetkili Kişi" value={f.contact_name} onChange={set("contact_name")} data-testid="cust-form-contact" />
        <Input label="Telefon" value={f.phone} onChange={set("phone")} data-testid="cust-form-phone" />
        <Input label="E-posta" type="email" value={f.email} onChange={set("email")} data-testid="cust-form-email" />
        <Input label="Telegram Kullanıcı Adı" placeholder="@kullanici" value={f.telegram_username || ""} onChange={set("telegram_username")} data-testid="cust-form-telegram" />
        <div className="sm:col-span-2"><Textarea label="Adres" value={f.billing_address || ""} onChange={set("billing_address")} data-testid="cust-form-address" /></div>
        <div className="sm:col-span-2"><Textarea label="Notlar" value={f.notes || ""} onChange={set("notes")} data-testid="cust-form-notes" /></div>
        <Select label="Durum" value={f.active ? "1" : "0"} onChange={(e) => setF({ ...f, active: e.target.value === "1" })} data-testid="cust-form-active">
          <option value="1">Aktif</option><option value="0">Pasif</option>
        </Select>
      </div>
      {err && <div className="mt-3 text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="cust-form-error">{err}</div>}
      <div className="flex justify-end gap-2 mt-4">
        <Btn variant="secondary" onClick={onClose} data-testid="cust-form-cancel">Vazgeç</Btn>
        <Btn onClick={save} disabled={busy} data-testid="cust-form-save">{busy ? "Kaydediliyor…" : "Kaydet"}</Btn>
      </div>
    </Modal>
  );
}
